<template>
  <div>
    <h1 class="title">Sales Points</h1>
    <div class="section has-text-left">
      <router-link to="/sales-point" class="button is-success">
        <b-icon icon="plus-square" size="is-small"></b-icon>
        <span>Aggiungi</span>
      </router-link>
    </div>

    <section class="content">
      <SearchSalesPointAsync
        v-on:eventGotResults="handleGotResults"
      ></SearchSalesPointAsync>
    </section>

    <section>
      <b-table
        :data="dataList"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :loading="$ajax.anyLoading"
        striped
        class="has-text-left"
      >
        <template>
          <b-table-column field="name" label="Ragione Sociale" v-slot="props">
            <router-link
              :to="`/sales-point/${props.row.id}`"
              :title="props.row.name"
            >
              <i class="fas fa-edit"></i>
              {{ props.row.name | truncate(35) }}
            </router-link>
          </b-table-column>

          <b-table-column field="city" label="Città" v-slot="props">{{
            props.row.city
          }}</b-table-column>

          <b-table-column field="tipology" label="Tipologia" v-slot="props">{{
            $ajax.getObject("servicesTipology", props.row.tipologyId).name
          }}</b-table-column>

          <b-table-column field="vatNumber" label="P.IVA" v-slot="props">{{
            props.row.vatNumber
          }}</b-table-column>

          <b-table-column
            field="updatedat"
            label="Updated"
            v-slot="props"
            centered
          >
            <span class="tag">{{ props.row.updatedAt | date }}</span>
          </b-table-column>
        </template>

        <template slot="detail">
          <div>async load stats?</div>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="cash-register" size="is-large"></b-icon>
              </p>
              <p>Lista sales point vuota</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import SearchSalesPointAsync from "../components/SearchSalesPointAsync";

export default {
  name: "sales-points",
  components: { SearchSalesPointAsync },
  data() {
    return {
      dataList: [],
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 20,
    };
  },
  methods: {
    handleGotResults(dataList) {
      this.dataList = dataList;
    },
  },
  mounted() {
    const vm = this;
    var r = this.$ajax.request({
      address: "/salespoints/latest/",
      method: "GET",
      onSuccess: (response) => {
        response.data.forEach((item) => vm.dataList.push(item));
      },
    });
  },
};
</script>
